// extracted by mini-css-extract-plugin
export var animating = "_redotech-redo-web-lib-dropdown-animating";
export var background = "_redotech-redo-web-lib-dropdown-background";
export var constrainHeight = "_redotech-redo-web-lib-dropdown-constrain-height";
export var dark = "_redotech-redo-web-lib-dropdown-dark";
export var dropdown = "_redotech-redo-web-lib-dropdown-dropdown";
export var leave = "_redotech-redo-web-lib-dropdown-leave";
export var option = "_redotech-redo-web-lib-dropdown-option";
export var root = "_redotech-redo-web-lib-dropdown-root";